import { IconButton, Tooltip } from '@ads/components-react';
import { MinusIcon, PlusIcon, ViewfinderCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export interface ZoomControlProps {
  readonly zoom: number;
  readonly onZoomIn: () => void;
  readonly onZoomOut: () => void;
  readonly onZoomReset: () => void;
  readonly onZoomFit: () => void;
  readonly showGuides: boolean;
  readonly onToggleGuides: () => void;
}

export function ZoomControl({
  zoom,
  onZoomIn,
  onZoomOut,
  onZoomReset,
  onZoomFit,
  showGuides,
  onToggleGuides,
}: ZoomControlProps) {
  const { t } = useTranslation('slideEditor');

  return (
    <div className="flex items-center overflow-hidden rounded-sm border-hairline border-ctx-layout-border">
      <IconButton
        icon={MinusIcon}
        hierarchy="tertiary"
        size="sm"
        ariaLabel={t('zoom.zoomOut')}
        onClick={onZoomOut}
      />
      <button
        className="min-w-[2.75rem] border-x-hairline border-ctx-layout-border bg-ctx-layout-body px-nano text-center text-ctx-content-base transition-colors ts-caption-xxs hover:text-ctx-content-title"
        onClick={onZoomReset}
        title={t('zoom.reset')}
        type="button"
      >
        {Math.round(zoom * 100)}%
      </button>
      <IconButton
        icon={PlusIcon}
        hierarchy="tertiary"
        size="sm"
        ariaLabel={t('zoom.zoomIn')}
        onClick={onZoomIn}
      />
      <Tooltip title={t('zoom.fit')}>
        <button
          className="border-l-hairline border-ctx-layout-border bg-ctx-layout-body px-nano text-ctx-content-base transition-colors ts-caption-xxs hover:text-ctx-content-title"
          onClick={onZoomFit}
          type="button"
        >
          Fit
        </button>
      </Tooltip>
      <Tooltip title={t('zoom.toggleGuides')}>
        <IconButton
          type="button"
          onClick={onToggleGuides}
          ariaLabel={t('zoom.toggleGuides')}
          aria-pressed={showGuides}
          size="sm"
          hierarchy={showGuides ? 'primary' : 'tertiary'}
          icon={ViewfinderCircleIcon}
        />
      </Tooltip>
    </div>
  );
}
